<template>
  <div class="teacher-page">
    <el-card shadow="never" class="me-card" v-if="me">
      <div class="me-row">
        <span>当前账号：<b>{{ me.username }}</b></span>
        <span v-if="me.subjectName">任教学科：<b>{{ me.subjectName }}</b></span>
        <span v-else class="warn">未配置任教学科，请联系管理员在「管理员管理」中为您设置</span>
      </div>
    </el-card>

    <el-row :gutter="16">
      <el-col :xs="24" :md="10">
        <el-card shadow="never" header="我的教学班">
          <div class="toolbar">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate" :disabled="isAdminView">新建班级</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="loadClasses">刷新</el-button>
          </div>
          <el-table ref="classTable" :data="classes" border stripe size="small" v-loading="loadingClasses" highlight-current-row @current-change="onSelectClass">
            <el-table-column prop="name" label="班级名称" min-width="120" />
            <el-table-column prop="subjectName" label="学科" width="80" />
            <el-table-column prop="gradeName" label="年级" width="80" />
            <el-table-column prop="studentCount" label="人数" width="60" />
            <el-table-column v-if="isAdminView" prop="teacherUsername" label="任课教师" width="100" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :md="14">
        <el-card shadow="never" v-if="current">
          <div slot="header" class="hdr">
            <span>{{ current.name }}  — 学情</span>
            <div v-if="!isAdminView">
              <el-button type="text" size="small" @click="openEditClass">改名/年级</el-button>
              <el-button type="text" size="small" class="danger" @click="deleteClass">删除班级</el-button>
            </div>
          </div>

          <el-tabs v-model="tab">
            <el-tab-pane label="学生名单" name="stu">
              <div class="toolbar" v-if="!isAdminView">
                <el-input v-model="addUsername" placeholder="用户名 / 真实姓名 / 手机号" style="width:220px" size="small" clearable />
                <el-button type="primary" size="small" @click="addStudent">加入班级</el-button>
              </div>
              <el-table :data="students" border stripe size="small" v-loading="loadingStu">
                <el-table-column prop="realName" label="真实姓名" width="100" />
                <el-table-column prop="username" label="用户名" width="120" />
                <el-table-column label="学校" min-width="140">
                  <template #default="{ row }">
                    <span v-if="!isAdminView && editingSchoolUserId === row.userId">
                      <el-input v-model="schoolDraft" size="mini" style="width:120px" maxlength="100" />
                      <el-button type="text" size="mini" @click="saveStudentSchool(row)">保存</el-button>
                      <el-button type="text" size="mini" @click="cancelEditSchool">取消</el-button>
                    </span>
                    <span v-else>
                      {{ row.school || '—' }}
                      <el-button v-if="!isAdminView" type="text" size="mini" @click="startEditSchool(row)">编辑</el-button>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="学情" width="72">
                  <template #default="{ row }">
                    <el-button type="text" size="small" @click="openStudentTrend(row)">曲线</el-button>
                  </template>
                </el-table-column>
                <el-table-column v-if="!isAdminView" label="操作" width="80">
                  <template #default="{ row }">
                    <el-button type="text" class="danger" size="small" @click="removeStudent(row)">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="课次与试卷" name="lesson">
              <p class="hint">
                为班级建立课次（第几课），并绑定本场考试用的试卷。学生完成该卷后，学情与成长曲线会显示为「第 N 课」。
              </p>
              <div class="toolbar" v-if="!isAdminView">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="openLessonDlg()">新建课次</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="loadLessons">刷新</el-button>
              </div>
              <el-table :data="lessons" border stripe size="small" v-loading="loadingLessons">
                <el-table-column prop="lessonNo" label="课次" width="72">
                  <template #default="{ row }">第{{ row.lessonNo }}课</template>
                </el-table-column>
                <el-table-column label="知识点" min-width="140" show-overflow-tooltip>
                  <template #default="{ row }">
                    {{ row.knowledgeTagPath || row.knowledgeTagName || row.title || '—' }}
                  </template>
                </el-table-column>
                <el-table-column label="绑定试卷" min-width="160" show-overflow-tooltip>
                  <template #default="{ row }">
                    <span v-if="row.paperTitle">{{ row.paperTitle }}（{{ row.paperQuestionCount || 0 }} 题）</span>
                    <span v-else class="muted">未绑定</span>
                  </template>
                </el-table-column>
                <el-table-column label="上课时间" width="150">
                  <template #default="{ row }">{{ formatLessonTime(row.lessonAt) }}</template>
                </el-table-column>
                <el-table-column v-if="!isAdminView" label="操作" width="120">
                  <template #default="{ row }">
                    <el-button type="text" size="small" @click="openLessonDlg(row)">编辑</el-button>
                    <el-button type="text" class="danger" size="small" @click="deleteLesson(row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="班级高频错题" name="wrong">
              <div class="wrong-toolbar">
                <span class="wrong-toolbar-label">课次</span>
                <el-select
                  v-model="wrongLessonIds"
                  multiple
                  collapse-tags
                  clearable
                  filterable
                  placeholder="全部课次（可多选）"
                  size="small"
                  style="width:360px"
                  @change="loadWrong"
                >
                  <el-option
                    v-for="l in lessonsWithPaper"
                    :key="l.id"
                    :label="formatWrongLessonLabel(l)"
                    :value="l.id"
                  />
                </el-select>
                <el-button
                  size="small"
                  icon="el-icon-download"
                  :loading="exportingWrong"
                  :disabled="!wrongRows.length || wrongLessonMissingPaper"
                  @click="openWrongExportDlg"
                >导出错题 PDF</el-button>
                <span v-if="selectedWrongRows.length" class="wrong-select-tip">已选 {{ selectedWrongRows.length }} 题</span>
              </div>
              <p v-if="wrongLessonMissingPaper" class="hint">所选课次中有未绑定试卷的课次，请取消选择或先绑定试卷。</p>
              <p v-else class="hint">勾选需要讲练的题目后导出；课次可多选，不必选全部。</p>
              <el-table
                ref="wrongTable"
                :data="wrongRows"
                border
                stripe
                size="small"
                v-loading="loadingWrong"
                row-key="questionId"
                @selection-change="onWrongSelectionChange"
              >
                <el-table-column type="selection" width="45" reserve-selection />
                <el-table-column prop="wrongCount" label="人数" width="70" />
                <el-table-column prop="contentBrief" label="题干摘要" min-width="220" show-overflow-tooltip />
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="成绩分布（本学科试卷）" name="score">
              <div v-loading="loadingScore">
                <p class="hint">
                  按<b>试卷</b>分别统计本班学生在「{{ current.subjectName }}」各套卷的得分（0–100）。下方先展示<b>全科汇总</b>分数段分布，展开每场试卷可查看<b>每位学生最近一次</b>得分。
                </p>
                <template v-if="scoreData">
                  <div class="score-overall">
                    <div class="block-title">全科汇总（本科全部相关试卷）</div>
                    <p class="avg">合计作答 <b>{{ scoreData.totalRecords }}</b> 次
                      <span v-if="scoreData.avgScore != null">，总平均分 <b>{{ scoreData.avgScore }}</b></span>
                    </p>
                    <div class="bars">
                      <div v-for="b in scoreData.buckets || []" :key="'all-' + b.label" class="bar-row">
                        <span class="lbl">{{ b.label }}</span>
                        <div class="bar-wrap">
                          <div class="bar-fill" :style="{ width: distBarWidth(b.count) }" />
                        </div>
                        <span class="cnt">{{ b.count }}</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="!(scoreData.papers && scoreData.papers.length)" class="muted paper-empty">暂无按卷拆分的作答记录（学生完成该学科试卷后会出现在此）。</div>
                  <el-collapse v-else v-model="scorePaperActive" class="paper-collapse">
                    <el-collapse-item v-for="p in scoreData.papers" :key="p.paperId" :name="String(p.paperId)">
                      <template slot="title">
                        <div class="paper-collapse-head">
                          <div class="paper-collapse-title-row" :title="p.displayTitle || p.paperTitle">
                            {{ p.displayTitle || p.paperTitle }}
                          </div>
                          <div class="paper-collapse-meta-row">
                            <span v-if="p.lessonNo">第{{ p.lessonNo }}课</span>
                            <span>{{ p.studentCount || 0 }} 人作答</span>
                            <span>合计 {{ p.totalRecords }} 次</span>
                            <span>卷均 {{ p.avgScore != null ? p.avgScore : '—' }}</span>
                            <span>试卷ID {{ p.paperId }}</span>
                          </div>
                        </div>
                      </template>
                      <div class="paper-student-scores">
                        <div v-if="!(p.students && p.students.length)" class="muted paper-empty">暂无学生作答记录</div>
                        <div v-for="s in p.students || []" :key="s.userId" class="student-score-row">
                          <span class="stu-name" :title="s.username">{{ s.displayName || s.realName || s.nickname || s.username }}</span>
                          <div class="stu-bar-wrap">
                            <div class="stu-bar-fill" :style="{ width: studentScoreBarWidth(s.latestScore) }" />
                          </div>
                          <span class="stu-score">{{ s.latestScore != null ? s.latestScore : '—' }}</span>
                        </div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </template>
              </div>
            </el-tab-pane>
            <el-tab-pane label="学生成长曲线" name="trend">
              <div v-loading="loadingTrend">
                <p class="hint">
                  横轴可选<b>第几次课</b>或<b>完成时间</b>。折线图每个课次只显示<b>最高</b>成绩；下方表格列出<b>每一次</b>作答记录。
                  绿线为<b>该卷</b>本班均分（按每位学生该卷最新成绩计算，同卷各点班均相同）。
                  可筛选单场试卷，或选「全部场次」查看跨课次折线。
                </p>
                <div class="trend-toolbar">
                  <el-select v-model="trendStudentId" placeholder="选择学生" size="small" style="width:200px" clearable @change="onTrendStudentChange">
                    <el-option
                      v-for="s in students"
                      :key="s.userId"
                      :label="(s.realName || s.nickname || s.username) + '（' + s.username + '）'"
                      :value="s.userId"
                    />
                  </el-select>
                  <el-select
                    v-if="trendSource === 'paper' && trendPaperOptions.length"
                    v-model="trendPaperFilter"
                    placeholder="查看范围"
                    size="small"
                    style="width:240px"
                    clearable
                  >
                    <el-option label="全部场次" :value="''" />
                    <el-option
                      v-for="opt in trendPaperOptions"
                      :key="opt.id"
                      :label="opt.label"
                      :value="opt.id"
                    />
                  </el-select>
                  <el-radio-group v-model="trendSource" size="small" @change="onTrendSourceChange">
                    <el-radio-button label="paper">试卷考试</el-radio-button>
                    <el-radio-button label="practice">刷题记录</el-radio-button>
                  </el-radio-group>
                  <el-radio-group v-model="trendXMode" size="small">
                    <el-radio-button label="index">横轴：第几次课</el-radio-button>
                    <el-radio-button label="time">横轴：时间</el-radio-button>
                  </el-radio-group>
                  <el-button size="small" icon="el-icon-refresh" :disabled="!trendStudentId" @click="loadTrend">刷新</el-button>
                </div>

                <div v-if="trendFilteredEmpty && trendStudentId" class="muted paper-empty">
                  该学生尚未作答所选试卷。
                </div>
                <template v-else-if="trendTablePoints.length">
                  <div class="trend-summary">
                    共 <b>{{ trendDisplaySummary.pointCount }}</b> 次课：
                    高于该卷班均 <b class="up">{{ trendDisplaySummary.aboveCount }}</b> 次，
                    低于班均 <b class="down">{{ trendDisplaySummary.belowCount }}</b> 次，
                    持平 <b>{{ trendDisplaySummary.equalCount }}</b> 次
                    <span v-if="trendTablePoints.length > trendChartPoints.length" class="muted">
                      （表格共 {{ trendTablePoints.length }} 条作答记录）
                    </span>
                  </div>

                  <div class="trend-chart-wrap">
                    <svg class="trend-chart" viewBox="0 0 640 280" preserveAspectRatio="xMidYMid meet">
                      <line v-for="y in trendYTicks" :key="'gy-' + y" :x1="48" :y1="trendY(y)" :x2="620" :y2="trendY(y)" class="grid-line" />
                      <text v-for="y in trendYTicks" :key="'yl-' + y" :x="42" :y="trendY(y) + 4" class="axis-label" text-anchor="end">{{ y }}</text>
                      <polyline v-if="trendClassPath" :points="trendClassPath" class="line-class-underlay" fill="none" />
                      <polyline v-if="trendClassPath" :points="trendClassPath" class="line-class" fill="none" />
                      <polyline v-if="trendStudentPath" :points="trendStudentPath" class="line-student" fill="none" />
                      <g v-for="(p, i) in trendChartPoints" :key="'pt-' + (p.recordId || i)">
                        <circle
                          v-if="p.classAvgScore != null && !trendScoresEqual(p)"
                          :cx="trendX(i)"
                          :cy="trendY(p.classAvgScore)"
                          r="3.5"
                          class="dot-class"
                        />
                        <circle
                          v-if="p.classAvgScore != null && trendScoresEqual(p)"
                          :cx="trendX(i)"
                          :cy="trendY(p.classAvgScore)"
                          r="7"
                          class="dot-coincide-ring"
                        />
                        <circle v-if="p.studentScore != null" :cx="trendX(i)" :cy="trendY(p.studentScore)" r="4" class="dot-student" />
                        <text
                          v-if="trendXLabelShow(i)"
                          :x="trendX(i)"
                          :y="268"
                          class="x-label"
                          text-anchor="middle"
                        >{{ trendXLabel(p, i) }}</text>
                      </g>
                    </svg>
                    <div class="trend-legend">
                      <span><i class="lg student" />该生得分</span>
                      <span><i class="lg class" />班级均分（该卷）</span>
                    </div>
                    <p v-if="trendAllScoresEqualClass" class="trend-coincide-hint">
                      该生得分与班均一致时，蓝线与绿虚线会重合；已用浅绿加粗底轨与空心圈标出班均位置，具体数值见下表。
                    </p>
                  </div>

                  <el-table :data="trendTablePoints" border stripe size="small" class="trend-table">
                    <el-table-column prop="index" label="#" width="44" />
                    <el-table-column prop="label" label="场次" min-width="140" show-overflow-tooltip />
                    <el-table-column label="完成时间" width="150">
                      <template #default="{ row }">{{ formatTrendTime(row.finishedAt) }}</template>
                    </el-table-column>
                    <el-table-column label="该生得分" width="88">
                      <template #default="{ row }"><b>{{ row.studentScore }}</b></template>
                    </el-table-column>
                    <el-table-column width="100">
                      <template slot="header">
                        <span>班均分</span>
                        <span class="col-hint">（该卷）</span>
                      </template>
                      <template #default="{ row }">{{ row.classAvgScore }}</template>
                    </el-table-column>
                    <el-table-column label="与班均差" width="96">
                      <template #default="{ row }">
                        <span v-if="row.diff == null">—</span>
                        <span v-else :class="row.aboveClassAvg ? 'up' : (row.diff == 0 ? '' : 'down')">
                          {{ row.diff > 0 ? '+' : '' }}{{ row.diff }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="participantCount" label="参考人数" width="88" />
                  </el-table>
                </template>
                <div v-else-if="trendStudentId && !loadingTrend" class="muted paper-empty">
                  该学生暂无{{ trendSource === 'practice' ? '刷题' : '本学科试卷' }}作答记录。
                </div>
                <div v-else-if="!trendStudentId" class="muted paper-empty">请先从上方选择一名学生，或在学生名单中点击「曲线」。</div>
              </div>
            </el-tab-pane>

          </el-tabs>
        </el-card>
        <el-card v-else shadow="never" class="empty-hint">
          <p>请从左侧选择一个班级查看学情。</p>
          <p v-if="isAdminView" class="muted">管理员可查看全部班级；分班、加减学生请使用教师账号登录。</p>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="新建教学班" :visible.sync="dlgCreate" width="420px" @closed="createForm = { name: '', gradeId: null }">
      <el-form label-width="88px">
        <el-form-item label="班级名称" required>
          <el-input v-model="createForm.name" placeholder="如：一年级1班" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="createForm.gradeId" clearable placeholder="可选" style="width:100%">
            <el-option v-for="g in grades" :key="g.id" :label="g.name" :value="g.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dlgCreate = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitCreate">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="lessonEditMode ? '编辑课次' : '新建课次'" :visible.sync="dlgLesson" width="680px" @closed="resetLessonForm">
      <el-form label-width="96px">
        <el-form-item label="第几课" required>
          <el-input-number v-model="lessonForm.lessonNo" :min="1" :max="999" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item v-if="!lessonClassHasGrade" label="学段">
          <el-select v-model="lessonForm.lessonStageId" placeholder="请选择学段" style="width:100%" @change="onLessonStageChange">
            <el-option v-for="s in lessonStages" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="知识点">
          <el-autocomplete
            v-model="lessonForm.knowledgeText"
            :fetch-suggestions="queryKnowledgeSuggestions"
            :trigger-on-focus="true"
            :disabled="!lessonStageIdForTags"
            clearable
            placeholder="下拉选择或手动输入知识点"
            popper-class="lesson-knowledge-suggestions"
            style="width:100%"
            @select="onKnowledgeSelect"
            @input="onKnowledgeInput"
          />
          <p v-if="!lessonStageIdForTags" class="field-hint">请先为班级设置年级，或选择学段后再选知识点</p>
          <p v-else class="field-hint">可从标签库选择，也可直接输入自定义内容</p>
        </el-form-item>
        <el-form-item label="绑定试卷">
          <el-select v-model="lessonForm.paperId" clearable filterable placeholder="选择本学科已发布试卷" style="width:100%">
            <el-option
              v-for="p in lessonPaperOptions"
              :key="p.id"
              :label="p.title + '（' + (p.questionCount || 0) + ' 题）'"
              :value="p.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="上课时间">
          <el-date-picker
            v-model="lessonForm.lessonAt"
            type="datetime"
            placeholder="可选"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dlgLesson = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitLesson">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑班级" :visible.sync="dlgEdit" width="420px">
      <el-form label-width="88px">
        <el-form-item label="班级名称" required>
          <el-input v-model="editClassForm.name" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="editClassForm.gradeId" clearable placeholder="可选" style="width:100%">
            <el-option v-for="g in grades" :key="g.id" :label="g.name" :value="g.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dlgEdit = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitEditClass">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导出错题 PDF" :visible.sync="wrongExportDlgVisible" width="460px">
      <el-form label-width="90px">
        <el-form-item label="导出题目">
          <span>{{ selectedWrongRows.length }} / {{ wrongRows.length }} 道</span>
          <el-button type="text" size="mini" @click="selectAllWrongRows">全选</el-button>
          <el-button type="text" size="mini" @click="clearWrongSelection">清空</el-button>
        </el-form-item>
        <el-form-item label="PDF 版本">
          <el-radio-group v-model="wrongExportVersion">
            <el-radio label="student">学生版（无答案解析，留作答区）</el-radio>
            <el-radio label="teacher">教师版（含答案和解析）</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="wrongExportDlgVisible = false">取消</el-button>
        <el-button type="primary" :loading="exportingWrong" @click="exportWrong">确认导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import teacherRequest from '../../utils/teacherRequest'

export default {
  name: 'TeacherClassManage',
  data() {
    return {
      me: null,
      classes: [],
      current: null,
      students: [],
      wrongRows: [],
      wrongLessonIds: [],
      selectedWrongRows: [],
      wrongExportDlgVisible: false,
      wrongExportVersion: 'student',
      exportingWrong: false,
      scoreData: null,
      scorePaperActive: [],
      trendStudentId: null,
      trendSource: 'paper',
      trendData: null,
      trendPaperFilter: '',
      trendXMode: 'index',
      loadingTrend: false,
      trendYTicks: [0, 20, 40, 60, 80, 100],
      tab: 'stu',
      addUsername: '',
      editingSchoolUserId: null,
      schoolDraft: '',
      grades: [],
      loadingClasses: false,
      loadingStu: false,
      loadingWrong: false,
      loadingScore: false,
      dlgCreate: false,
      dlgEdit: false,
      saving: false,
      createForm: { name: '', gradeId: null },
      editClassForm: { name: '', gradeId: null },
      lessons: [],
      lessonPaperOptions: [],
      loadingLessons: false,
      dlgLesson: false,
      lessonEditMode: false,
      lessonForm: { id: null, lessonNo: 1, knowledgeText: '', knowledgeTagId: null, lessonStageId: null, paperId: null, lessonAt: null },
      lessonKnowledgeTree: [],
      lessonStages: [],
      suppressClassDeselect: false
    }
  },
  computed: {
    isAdminView() {
      try {
        const info = JSON.parse(localStorage.getItem('admin_info') || '{}')
        return info.role === 'ADMIN'
      } catch (e) {
        return false
      }
    },
    trendStudentPath() {
      return this.buildTrendPath('studentScore')
    },
    trendClassPath() {
      return this.buildTrendPath('classAvgScore')
    },
    trendPaperOptions() {
      const pts = (this.trendData && this.trendData.points) || []
      const map = new Map()
      pts.forEach(p => {
        if (p.paperId != null && !map.has(p.paperId)) {
          map.set(p.paperId, { id: p.paperId, label: p.label || ('试卷#' + p.paperId) })
        }
      })
      return Array.from(map.values())
    },
    trendTablePoints() {
      const pts = (this.trendData && this.trendData.points) || []
      if (this.trendSource !== 'paper' || !this.trendPaperFilter) return pts
      return pts.filter(p => p.paperId === this.trendPaperFilter)
    },
    trendChartPoints() {
      const pts = this.trendTablePoints
      if (this.trendSource !== 'paper') return pts
      const byPaper = new Map()
      pts.forEach(p => {
        if (p.paperId == null) return
        const score = p.studentScore != null ? Number(p.studentScore) : NaN
        if (Number.isNaN(score)) return
        const existing = byPaper.get(p.paperId)
        if (!existing) {
          byPaper.set(p.paperId, p)
          return
        }
        const existingScore = Number(existing.studentScore)
        if (score > existingScore) {
          byPaper.set(p.paperId, p)
          return
        }
        if (score === existingScore && p.finishedAt) {
          const t = new Date(p.finishedAt).getTime()
          const et = new Date(existing.finishedAt).getTime()
          if (!Number.isNaN(t) && !Number.isNaN(et) && t > et) {
            byPaper.set(p.paperId, p)
          }
        }
      })
      return Array.from(byPaper.values()).sort((a, b) => {
        const la = a.lessonNo != null ? a.lessonNo : Number.MAX_SAFE_INTEGER
        const lb = b.lessonNo != null ? b.lessonNo : Number.MAX_SAFE_INTEGER
        if (la !== lb) return la - lb
        const ta = new Date(a.finishedAt).getTime()
        const tb = new Date(b.finishedAt).getTime()
        return ta - tb
      })
    },
    trendFilteredEmpty() {
      return this.trendPaperFilter && this.trendTablePoints.length === 0
    },
    trendDisplaySummary() {
      const pts = this.trendChartPoints
      let above = 0
      let below = 0
      let equal = 0
      pts.forEach(p => {
        if (p.diff == null) return
        const d = Number(p.diff)
        if (d > 0) above++
        else if (d < 0) below++
        else equal++
      })
      return { pointCount: pts.length, aboveCount: above, belowCount: below, equalCount: equal }
    },
    /** 每个数据点该生得分都与班均相同（双线完全重合） */
    trendTimeRange() {
      const pts = this.trendChartPoints
      let min = null
      let max = null
      pts.forEach(p => {
        if (!p.finishedAt) return
        const t = new Date(p.finishedAt).getTime()
        if (Number.isNaN(t)) return
        if (min == null || t < min) min = t
        if (max == null || t > max) max = t
      })
      return { min, max }
    },
    trendAllScoresEqualClass() {
      const pts = this.trendChartPoints
      if (!pts || !pts.length) return false
      return pts.every(p => this.trendScoresEqual(p))
    },
    lessonClassHasGrade() {
      return !!(this.current && this.current.gradeId)
    },
    lessonStageIdForTags() {
      if (!this.current) return null
      if (this.current.gradeId) {
        const g = this.grades.find(x => x.id === this.current.gradeId)
        return g && g.stageId ? g.stageId : this.lessonForm.lessonStageId
      }
      return this.lessonForm.lessonStageId
    },
    lessonKnowledgeFlat() {
      return this.flattenKnowledgeTree(this.lessonKnowledgeTree)
    },
    wrongLessonMissingPaper() {
      if (!this.wrongLessonIds || !this.wrongLessonIds.length) return false
      return this.wrongLessonIds.some(id => {
        const lesson = (this.lessons || []).find(l => l.id === id)
        return !!(lesson && !lesson.paperId)
      })
    },
    lessonsWithPaper() {
      return (this.lessons || []).filter(l => l.paperId)
    }
  },
  watch: {
    tab(val) {
      if (!this.current) return
      if (val === 'lesson') this.loadLessons()
      if (val === 'wrong') {
        this.loadLessons()
        this.loadWrong()
      }
      if (val === 'score') this.loadScore()
      if (val === 'trend' && this.trendStudentId) this.loadTrend()
    }
  },
  created() {
    this.loadGrades()
    this.loadMe()
    this.loadClasses()
  },
  methods: {
    formatStudentName(row) {
      if (!row) return ''
      return row.realName || row.nickname || row.username || ''
    },
    trendScoresEqual(p) {
      if (!p || p.studentScore == null || p.classAvgScore == null) return false
      return Number(p.studentScore) === Number(p.classAvgScore)
    },
    loadGrades() {
      teacherRequest.get('/meta/grades').then(data => {
        this.grades = data || []
      }).catch(() => {})
    },
    loadMe() {
      teacherRequest.get('/me').then(data => { this.me = data }).catch(() => {})
    },
    loadClasses() {
      const selectedId = this.current ? this.current.id : null
      this.loadingClasses = true
      this.suppressClassDeselect = !!selectedId
      teacherRequest.get('/classes').then(data => {
        this.classes = data || []
        if (selectedId) {
          const hit = this.classes.find(c => c.id === selectedId)
          if (hit) {
            this.current = hit
            this.$nextTick(() => {
              if (this.$refs.classTable) {
                this.$refs.classTable.setCurrentRow(hit)
              }
              this.suppressClassDeselect = false
            })
          } else {
            this.current = null
            this.suppressClassDeselect = false
          }
        }
      }).catch(() => {
        this.suppressClassDeselect = false
      }).finally(() => { this.loadingClasses = false })
    },
    syncClassStudentCount() {
      if (!this.current) return
      const count = this.students.length
      this.current.studentCount = count
      const row = this.classes.find(c => c.id === this.current.id)
      if (row) row.studentCount = count
    },
    onSelectClass(row) {
      if (!row) {
        if (this.suppressClassDeselect) return
        this.current = null
        return
      }
      this.current = row
      this.tab = 'stu'
      this.students = []
      this.wrongRows = []
      this.wrongLessonIds = []
      this.selectedWrongRows = []
      this.scoreData = null
      this.trendData = null
      this.trendStudentId = null
      this.lessons = []
      this.editingSchoolUserId = null
      this.schoolDraft = ''
      if (row) {
        this.loadStudents()
        this.loadLessons()
        this.loadWrong()
        this.loadScore()
      }
    },
    loadStudents() {
      if (!this.current) return
      this.loadingStu = true
      teacherRequest.get(`/classes/${this.current.id}/students`).then(data => {
        this.students = data || []
        this.syncClassStudentCount()
      }).catch(() => {}).finally(() => { this.loadingStu = false })
    },
    loadLessons() {
      if (!this.current) return
      this.loadingLessons = true
      teacherRequest.get(`/classes/${this.current.id}/lessons`).then(data => {
        this.lessons = data || []
      }).catch(() => { this.lessons = [] }).finally(() => { this.loadingLessons = false })
    },
    loadLessonPaperOptions() {
      if (!this.current) return Promise.resolve()
      return teacherRequest.get(`/classes/${this.current.id}/lesson-papers`).then(data => {
        this.lessonPaperOptions = data || []
      }).catch(() => { this.lessonPaperOptions = [] })
    },
    openLessonDlg(row) {
      if (!this.current) return
      this.lessonEditMode = !!row
      if (row) {
        this.lessonForm = {
          id: row.id,
          lessonNo: row.lessonNo,
          knowledgeText: row.knowledgeTagPath || row.knowledgeTagName || row.title || '',
          knowledgeTagId: row.knowledgeTagId || null,
          lessonStageId: null,
          paperId: row.paperId || null,
          lessonAt: row.lessonAt || null
        }
      } else {
        const maxNo = this.lessons.reduce((m, l) => Math.max(m, l.lessonNo || 0), 0)
        this.lessonForm = { id: null, lessonNo: maxNo + 1, knowledgeText: '', knowledgeTagId: null, lessonStageId: null, paperId: null, lessonAt: null }
      }
      Promise.all([
        this.loadLessonPaperOptions(),
        this.loadLessonStages(),
        this.loadLessonKnowledgeTree(this.lessonStageIdForTags)
      ]).then(() => { this.dlgLesson = true })
    },
    resetLessonForm() {
      this.lessonForm = { id: null, lessonNo: 1, knowledgeText: '', knowledgeTagId: null, lessonStageId: null, paperId: null, lessonAt: null }
      this.lessonKnowledgeTree = []
    },
    loadLessonStages() {
      return teacherRequest.get('/stage').then(data => {
        this.lessonStages = data || []
      }).catch(() => { this.lessonStages = [] })
    },
    loadLessonKnowledgeTree(stageId) {
      if (!stageId) {
        this.lessonKnowledgeTree = []
        return Promise.resolve()
      }
      return teacherRequest.get('/tag-tree', { params: { tagType: 'knowledge', stageId } }).then(tree => {
        this.lessonKnowledgeTree = tree || []
      }).catch(() => { this.lessonKnowledgeTree = [] })
    },
    onLessonStageChange(stageId) {
      this.lessonForm.knowledgeText = ''
      this.lessonForm.knowledgeTagId = null
      this.loadLessonKnowledgeTree(stageId)
    },
    flattenKnowledgeTree(nodes, parentPath = '') {
      const out = []
      ;(nodes || []).forEach(n => {
        const path = parentPath ? `${parentPath} / ${n.name}` : n.name
        out.push({ value: path, id: n.id, path })
        if (n.children && n.children.length) {
          out.push(...this.flattenKnowledgeTree(n.children, path))
        }
      })
      return out
    },
    queryKnowledgeSuggestions(queryString, cb) {
      const q = (queryString || '').trim().toLowerCase()
      const list = this.lessonKnowledgeFlat
      const res = q
        ? list.filter(item => item.value.toLowerCase().includes(q))
        : list.slice(0, 80)
      cb(res)
    },
    onKnowledgeSelect(item) {
      this.lessonForm.knowledgeTagId = item.id
      this.lessonForm.knowledgeText = item.path
    },
    onKnowledgeInput(val) {
      const text = (val || '').trim()
      const exact = this.lessonKnowledgeFlat.find(x => x.path === text || x.value === text)
      this.lessonForm.knowledgeTagId = exact ? exact.id : null
    },
    submitLesson() {
      if (!this.current) return
      if (!this.lessonForm.lessonNo || this.lessonForm.lessonNo < 1) {
        this.$message.warning('请填写第几课')
        return
      }
      const knowledgeText = (this.lessonForm.knowledgeText || '').trim()
      const body = {
        lessonNo: this.lessonForm.lessonNo,
        knowledgeTagId: this.lessonForm.knowledgeTagId,
        paperId: this.lessonForm.paperId,
        lessonAt: this.lessonForm.lessonAt
      }
      if (!this.lessonForm.knowledgeTagId) {
        body.title = knowledgeText || null
      }
      this.saving = true
      const req = this.lessonEditMode
        ? teacherRequest.put(`/classes/${this.current.id}/lessons/${this.lessonForm.id}`, body)
        : teacherRequest.post(`/classes/${this.current.id}/lessons`, body)
      req.then(() => {
        this.$message.success('已保存')
        this.dlgLesson = false
        this.loadLessons()
        if (this.tab === 'score') this.loadScore()
        if (this.tab === 'trend' && this.trendStudentId) this.loadTrend()
      }).catch(() => {}).finally(() => { this.saving = false })
    },
    deleteLesson(row) {
      if (!this.current) return
      this.$confirm(`确定删除第 ${row.lessonNo} 课？`, '提示', { type: 'warning' }).then(() => {
        teacherRequest.delete(`/classes/${this.current.id}/lessons/${row.id}`).then(() => {
          this.$message.success('已删除')
          this.loadLessons()
        })
      }).catch(() => {})
    },
    formatLessonTime(t) {
      if (!t) return '—'
      return String(t).replace('T', ' ').slice(0, 16)
    },
    loadWrong() {
      if (!this.current) return
      this.loadingWrong = true
      this.selectedWrongRows = []
      const qs = new URLSearchParams({ limit: '30' })
      if (this.wrongLessonIds && this.wrongLessonIds.length) {
        this.wrongLessonIds.forEach(id => qs.append('lessonIds', id))
      }
      teacherRequest.get(`/classes/${this.current.id}/wrong-summary?${qs.toString()}`).then(data => {
        this.wrongRows = data || []
        this.$nextTick(() => this.selectAllWrongRows())
      }).catch(() => { this.wrongRows = [] }).finally(() => { this.loadingWrong = false })
    },
    onWrongSelectionChange(rows) {
      this.selectedWrongRows = rows || []
    },
    selectAllWrongRows() {
      const table = this.$refs.wrongTable
      if (!table) return
      table.clearSelection()
      this.wrongRows.forEach(row => table.toggleRowSelection(row, true))
    },
    clearWrongSelection() {
      const table = this.$refs.wrongTable
      if (table) table.clearSelection()
      this.selectedWrongRows = []
    },
    openWrongExportDlg() {
      if (!this.current) return
      if (!this.wrongRows.length) {
        this.$message.warning('暂无错题可导出')
        return
      }
      if (this.wrongLessonMissingPaper) {
        this.$message.warning('所选课次中有未绑定试卷的课次，无法导出')
        return
      }
      if (!this.selectedWrongRows.length) {
        this.$message.warning('请先勾选要导出的题目')
        return
      }
      this.wrongExportDlgVisible = true
    },
    formatWrongLessonLabel(lesson) {
      if (!lesson) return ''
      const topic = lesson.knowledgeTagPath || lesson.knowledgeTagName || lesson.title
      let label = `第${lesson.lessonNo}课`
      if (topic) label += ` · ${topic}`
      if (lesson.paperTitle) label += `（${lesson.paperTitle}）`
      else label += '（未绑卷）'
      return label
    },
    exportWrong() {
      if (!this.current) return
      if (!this.selectedWrongRows.length) {
        this.$message.warning('请先勾选要导出的题目')
        return
      }
      this.exportingWrong = true
      const params = new URLSearchParams({ limit: '100', version: this.wrongExportVersion })
      if (this.wrongLessonIds && this.wrongLessonIds.length) {
        this.wrongLessonIds.forEach(id => params.append('lessonIds', id))
      }
      this.selectedWrongRows.forEach(row => params.append('questionIds', row.questionId))
      const token = localStorage.getItem('admin_token')
      fetch(`/api/teacher/classes/${this.current.id}/wrong-summary/export?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}`, Accept: 'application/pdf' }
      }).then(async res => {
        const contentType = res.headers.get('content-type') || ''
        if (contentType.includes('application/json')) {
          const err = await res.json()
          this.$message.error(err.message || '导出失败')
          return
        }
        if (!res.ok) {
          this.$message.error('导出失败，请稍后重试')
          return
        }
        const blob = await res.blob()
        if (!blob.size) {
          this.$message.error('导出文件为空')
          return
        }
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        const versionLabel = this.wrongExportVersion === 'teacher' ? '教师版' : '学生版'
        const scope = this.wrongLessonIds && this.wrongLessonIds.length
          ? `已选${this.wrongLessonIds.length}课次`
          : '全部课次'
        a.download = `${this.current.name || '班级'}_${scope}_${versionLabel}_高频错题.pdf`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
        this.wrongExportDlgVisible = false
        this.$message.success('导出成功')
      }).catch(() => {
        this.$message.error('导出失败')
      }).finally(() => { this.exportingWrong = false })
    },
    loadScore() {
      if (!this.current) return
      this.loadingScore = true
      teacherRequest.get(`/classes/${this.current.id}/score-distribution`).then(data => {
        this.scoreData = data
        if (data && data.papers && data.papers.length) {
          this.scorePaperActive = data.papers.map(p => String(p.paperId))
        } else {
          this.scorePaperActive = []
        }
      }).catch(() => {}).finally(() => { this.loadingScore = false })
    },
    openStudentTrend(row) {
      this.trendStudentId = row.userId
      this.trendPaperFilter = ''
      this.tab = 'trend'
      this.loadTrend()
    },
    onTrendStudentChange() {
      this.trendPaperFilter = ''
      this.loadTrend()
    },
    onTrendSourceChange() {
      this.trendPaperFilter = ''
      this.loadTrend()
    },
    loadTrend() {
      if (!this.current || !this.trendStudentId) {
        this.trendData = null
        return
      }
      this.loadingTrend = true
      teacherRequest.get(`/classes/${this.current.id}/students/${this.trendStudentId}/score-trend`, {
        params: { source: this.trendSource }
      }).then(data => {
        this.trendData = data
      }).catch(() => {
        this.trendData = null
      }).finally(() => { this.loadingTrend = false })
    },
    trendX(i) {
      const pts = this.trendChartPoints
      const padL = 48
      const padR = 20
      const plotW = 640 - padL - padR
      const n = pts.length
      if (n <= 0) return padL + plotW / 2
      if (this.trendXMode === 'index') {
        if (n === 1) return padL + plotW / 2
        return padL + (i / (n - 1)) * plotW
      }
      const p = pts[i]
      if (!p || !p.finishedAt) return padL + plotW / 2
      const { min, max } = this.trendTimeRange
      const t = new Date(p.finishedAt).getTime()
      if (min == null || max == null || Number.isNaN(t)) return padL + plotW / 2
      if (max <= min) return padL + plotW / 2
      return padL + ((t - min) / (max - min)) * plotW
    },
    trendXLabelShow(i) {
      const n = this.trendChartPoints.length
      if (n <= 10) return true
      const step = Math.max(1, Math.ceil(n / 8))
      return i === 0 || i === n - 1 || i % step === 0
    },
    trendY(score) {
      const padT = 20
      const padB = 48
      const plotH = 280 - padT - padB
      const v = Number(score)
      if (Number.isNaN(v)) return padT + plotH
      return padT + plotH - (Math.max(0, Math.min(100, v)) / 100) * plotH
    },
    buildTrendPath(key) {
      const pts = this.trendChartPoints
      const parts = []
      pts.forEach((p, i) => {
        if (p[key] == null) return
        parts.push(`${this.trendX(i)},${this.trendY(p[key])}`)
      })
      return parts.join(' ')
    },
    trendXLabel(p, i) {
      if (this.trendXMode === 'index') {
        if (p.lessonNo != null) return `第${p.lessonNo}课`
        const n = i != null ? i + 1 : (p.index != null ? p.index : '')
        return n ? `第${n}课` : ''
      }
      return this.formatTrendTimeShort(p.finishedAt)
    },
    formatTrendTimeShort(t) {
      if (!t) return ''
      const s = String(t).replace('T', ' ')
      return s.length >= 16 ? s.slice(5, 16) : s
    },
    formatTrendTime(t) {
      if (!t) return '—'
      const s = String(t).replace('T', ' ')
      return s.length >= 16 ? s.slice(0, 16) : s
    },
    distBarWidth(count) {
      const buckets = (this.scoreData && this.scoreData.buckets) || []
      const max = Math.max(1, ...buckets.map(b => b.count || 0))
      const pct = Math.round(((count || 0) / max) * 100)
      return Math.max(4, pct) + '%'
    },
    studentScoreBarWidth(score) {
      const v = Number(score)
      if (Number.isNaN(v)) return '0%'
      return Math.max(2, Math.min(100, v)) + '%'
    },
    openCreate() {
      this.createForm = { name: '', gradeId: null }
      this.dlgCreate = true
    },
    submitCreate() {
      if (!this.createForm.name || !this.createForm.name.trim()) {
        this.$message.warning('请输入班级名称')
        return
      }
      this.saving = true
      teacherRequest.post('/classes', this.createForm).then(() => {
        this.$message.success('已创建')
        this.dlgCreate = false
        this.loadClasses()
      }).catch(() => {}).finally(() => { this.saving = false })
    },
    openEditClass() {
      if (!this.current) return
      this.editClassForm = { name: this.current.name, gradeId: this.current.gradeId }
      this.dlgEdit = true
    },
    submitEditClass() {
      if (!this.current) return
      this.saving = true
      teacherRequest.put(`/classes/${this.current.id}`, {
        name: this.editClassForm.name,
        gradeId: this.editClassForm.gradeId
      }).then(() => {
        this.$message.success('已保存')
        this.dlgEdit = false
        this.loadClasses()
      }).catch(() => {}).finally(() => { this.saving = false })
    },
    deleteClass() {
      if (!this.current) return
      this.$confirm(`确定删除班级「${this.current.name}」？将移除全部学生关联`, '警告', { type: 'warning' }).then(() => {
        teacherRequest.delete(`/classes/${this.current.id}`).then(() => {
          this.$message.success('已删除')
          this.current = null
          this.loadClasses()
        })
      }).catch(() => {})
    },
    addStudent() {
      if (!this.current) return
      const u = (this.addUsername || '').trim()
      if (!u) {
        this.$message.warning('请输入学生用户名')
        return
      }
      teacherRequest.post(`/classes/${this.current.id}/students`, { username: u }).then(data => {
        const name = this.formatStudentName(data)
        this.$message.success(name ? `「${name}」已加入班级` : '已加入班级')
        this.addUsername = ''
        this.loadStudents()
      }).catch(() => {})
    },
    startEditSchool(row) {
      this.editingSchoolUserId = row.userId
      this.schoolDraft = row.school || ''
    },
    cancelEditSchool() {
      this.editingSchoolUserId = null
      this.schoolDraft = ''
    },
    saveStudentSchool(row) {
      if (!this.current || !row.userId) return
      teacherRequest.put(`/classes/${this.current.id}/students/${row.userId}/school`, {
        school: this.schoolDraft
      }).then(data => {
        row.school = data.school || ''
        this.$message.success('学校已更新')
        this.cancelEditSchool()
      }).catch(() => {})
    },
    removeStudent(row) {
      this.$confirm(`将「${row.nickname || row.username}」移出班级？`, '提示').then(() => {
        teacherRequest.delete(`/classes/${this.current.id}/students/${row.userId}`).then(() => {
          const name = this.formatStudentName(row)
          this.$message.success(name ? `「${name}」已移出班级` : '已移除')
          this.loadStudents()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.teacher-page { max-width: 1200px; }
.me-card { margin-bottom: 16px; }
.me-row { display: flex; flex-wrap: wrap; gap: 16px; font-size: 14px; color: #333; }
.me-row .warn { color: #d48806; }
.toolbar { margin-bottom: 10px; display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.hdr { display: flex; justify-content: space-between; align-items: center; }
.danger { color: #ff4d4f !important; }
.empty-hint { min-height: 200px; color: #666; }
.empty-hint .muted { color: #999; font-size: 13px; margin-top: 8px; }
.hint { font-size: 13px; color: #666; margin-bottom: 8px; }
.wrong-toolbar { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; flex-wrap: wrap; }
.wrong-toolbar-label { font-size: 13px; color: #606266; white-space: nowrap; }
.wrong-select-tip { font-size: 12px; color: #1677ff; }
.field-hint { font-size: 12px; color: #909399; margin: 4px 0 0; line-height: 1.4; }
.avg { font-size: 14px; margin-bottom: 12px; }
.bars { margin-top: 8px; }
.bar-row { display: flex; align-items: center; margin-bottom: 10px; gap: 8px; }
.bar-row .lbl { width: 88px; font-size: 13px; color: #555; }
.bar-wrap { flex: 1; height: 18px; background: #f0f0f0; border-radius: 4px; overflow: hidden; }
.bar-fill { height: 100%; background: linear-gradient(90deg, #1677ff, #69c0ff); border-radius: 4px; transition: width 0.3s; }
.bar-row .cnt { width: 36px; text-align: right; font-size: 13px; }
.score-overall {
  margin-bottom: 16px;
  padding: 12px 14px;
  background: #f7f9fc;
  border-radius: 8px;
  border: 1px solid #e8ecf4;
}
.block-title { font-weight: 600; color: #333; margin-bottom: 8px; font-size: 14px; }
.paper-empty { margin-top: 8px; font-size: 13px; }
.paper-collapse { margin-top: 4px; border: none; }
.paper-collapse >>> .el-collapse-item__header {
  height: auto;
  min-height: 48px;
  line-height: 1.5;
  align-items: flex-start;
  padding-top: 10px;
  padding-bottom: 10px;
}
.paper-collapse >>> .el-collapse-item__arrow {
  margin-top: 4px;
}
.paper-collapse-head {
  flex: 1;
  min-width: 0;
  padding-right: 8px;
}
.paper-collapse-title-row {
  font-weight: 600;
  color: #1677ff;
  font-size: 14px;
  line-height: 1.5;
  word-break: break-word;
}
.paper-collapse-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin-top: 6px;
  font-size: 12px;
  color: #888;
  font-weight: normal;
  line-height: 1.4;
}
.paper-student-scores { padding: 4px 0 8px; }
.student-score-row { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }
.stu-name { width: 100px; flex-shrink: 0; font-size: 13px; color: #333; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.stu-bar-wrap { flex: 1; height: 16px; background: #f0f0f0; border-radius: 4px; overflow: hidden; }
.stu-bar-fill { height: 100%; background: linear-gradient(90deg, #389e0d, #95de64); border-radius: 4px; transition: width 0.3s; }
.stu-score { width: 40px; text-align: right; font-size: 13px; font-weight: 600; color: #1677ff; }
.bar-fill-paper { background: linear-gradient(90deg, #389e0d, #95de64); }
.trend-toolbar { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; margin-bottom: 12px; }
.trend-summary { font-size: 13px; color: #555; margin-bottom: 10px; }
.trend-chart-wrap { margin-bottom: 14px; }
.trend-chart { width: 100%; max-width: 640px; height: auto; display: block; }
.grid-line { stroke: #e8e8e8; stroke-width: 1; }
.axis-label { font-size: 11px; fill: #999; }
.x-label { font-size: 10px; fill: #666; }
.line-student { stroke: #1677ff; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
.line-class-underlay {
  stroke: rgba(82, 196, 26, 0.4);
  stroke-width: 9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.line-class { stroke: #52c41a; stroke-width: 2; stroke-dasharray: 8 5; stroke-linecap: round; stroke-linejoin: round; }
.dot-student { fill: #1677ff; }
.dot-class { fill: #52c41a; }
.dot-coincide-ring {
  fill: none;
  stroke: #52c41a;
  stroke-width: 2;
  opacity: 0.95;
}
.trend-coincide-hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #888;
  line-height: 1.5;
}
.trend-legend { display: flex; gap: 16px; margin-top: 6px; font-size: 12px; color: #666; }
.trend-legend .lg { display: inline-block; width: 20px; height: 3px; margin-right: 6px; vertical-align: middle; border-radius: 2px; }
.trend-legend .lg.student { background: #1677ff; }
.trend-legend .lg.class { background: #52c41a; }
.trend-table { margin-top: 8px; }
.up { color: #389e0d; }
.down { color: #cf1322; }
.muted { color: #999; }
.col-hint { font-size: 11px; color: #999; font-weight: normal; margin-left: 2px; }
.trend-single-card {
  margin-bottom: 14px;
  padding: 14px 16px;
  background: #f7f9fc;
  border: 1px solid #e8ecf4;
  border-radius: 8px;
}
.single-paper-title { font-size: 15px; font-weight: 600; color: #20314f; margin-bottom: 6px; }
.single-paper-meta { font-size: 12px; color: #888; margin: 0 0 8px; }
.single-hint { margin-bottom: 12px; }
.single-bars { display: flex; flex-direction: column; gap: 12px; }
.single-bar-item { display: flex; align-items: center; gap: 10px; }
.single-bar-item .bar-lbl { width: 100px; font-size: 13px; color: #555; flex-shrink: 0; }
.single-bar-item .bar-track { flex: 1; height: 22px; background: #eee; border-radius: 4px; overflow: hidden; }
.single-bar-item .bar-fill.student { height: 100%; background: linear-gradient(90deg, #1677ff, #69c0ff); border-radius: 4px; }
.single-bar-item .bar-fill.class { height: 100%; background: linear-gradient(90deg, #389e0d, #95de64); border-radius: 4px; }
.single-bar-item .bar-val { width: 36px; text-align: right; font-weight: 600; font-size: 14px; }
.single-diff { margin-top: 10px; font-size: 13px; color: #555; }
</style>

<style>
.lesson-knowledge-suggestions {
  min-width: 640px !important;
  max-width: min(92vw, 820px);
}
.lesson-knowledge-suggestions .el-autocomplete-suggestion li {
  white-space: normal;
  line-height: 1.45;
  padding: 8px 12px;
  word-break: break-word;
}
.lesson-knowledge-suggestions .el-autocomplete-suggestion__wrap {
  max-height: 300px;
}
</style>


